import React, { PropsWithChildren } from 'react';
import { Text } from '@ydistri/ds';

/**
 * Displays text in light grey. Used text describing calculation.
 * @param param0
 * @param param0.children
 * @constructor
 */
const CalculationDescriptiveText: React.FC<PropsWithChildren> = ({ children }) => {
  if (children) {
    return <Text $type="light">{children}</Text>;
  }
  return null;
};

export default CalculationDescriptiveText;
